import { useEffect, useRef, useState } from 'react'

export const APPOINTMENT_HOLD_SECONDS = 10 * 60

export function formatCountdownMinutes(seconds: number): string {
    const clamped = Math.max(0, seconds)
    const minutes = Math.floor(clamped / 60)
    const remainder = clamped % 60
    return `${minutes}:${String(remainder).padStart(2, '0')}`
}

interface UseCountdownOptions {
    durationSeconds?: number
    onExpired?: () => void
}

export function useCountdown({
    durationSeconds = APPOINTMENT_HOLD_SECONDS,
    onExpired,
}: UseCountdownOptions = {}) {
    const [secondsLeft, setSecondsLeft] = useState(durationSeconds)
    const expiredRef = useRef(false)
    const onExpiredRef = useRef(onExpired)
    onExpiredRef.current = onExpired

    const isExpired = secondsLeft <= 0

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setSecondsLeft((previous) => {
                const next = previous - 1
                if (next <= 0) {
                    window.clearInterval(intervalId)
                    if (!expiredRef.current) {
                        expiredRef.current = true
                        onExpiredRef.current?.()
                    }
                    return 0
                }
                return next
            })
        }, 1000)

        return () => window.clearInterval(intervalId)
    }, [])

    return {
        secondsLeft,
        isExpired,
        formattedTime: formatCountdownMinutes(secondsLeft),
    }
}
